module.exports = __webpack_public_path__ + "img/icon_1573.92841314.svg";